module.exports = __webpack_public_path__ + "static/media/039.ee1d62b3.jpg";